module.exports = __webpack_public_path__ + "img/M_map_1.7db97336.png";